import {createContext} from "react";

export const CartConfigContext = createContext({});

export const useCartConfig = () => React.useContext(CartConfigContext);
